$(document).ready(function () {
  // =============== collection page slider JS Start ================
  $(".collection-slider").slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 4.5, slidesToScroll: 1 },
      },
    ],
  });
  // ============== collection page slider JS End ================

 // ============== Special Product JS Start ================

    //  Checkbox  show/hide  
    // $(document).on("click", ".special-gift-info", function () {
    //   const checkbox = $(this).find(".special-gift-checkbox");
    //   checkbox.prop("checked", !checkbox.prop("checked"));
    //   const cartGiftBlock = $(this).closest(".cart-special-gift");

    //     if (checkbox.is(":checked")) {
    //       cartGiftBlock.addClass("active");
    //     } else {
    //       cartGiftBlock.removeClass("active"); 
    //     }
    // });

    $(document).on("change", ".special-gift-checkbox", function () {
      const checkbox = $(this);
      const cartGiftBlock = checkbox.closest(".cart-special-gift");
      if (checkbox.is(":checked")) {
        cartGiftBlock.addClass("active");
      } else {
        cartGiftBlock.removeClass("active");
      }
    });

    
    // Quantity  button logic
    $(document).on("click", ".qty-btn.plus", function (e) {
      e.preventDefault();
      const $input = $(this).closest(".quantity-stepper").find(".qty-input");
      let currentVal = parseInt($input.val());
      $input.val(currentVal + 1); // Increase value by 1
    });
    
    
    $(document).on("click", ".qty-btn.minus", function (e) {
      e.preventDefault();
      const $input = $(this).closest(".quantity-stepper").find(".qty-input");
      let currentVal = parseInt($input.val());
      if (currentVal > 1) {
        $input.val(currentVal - 1); 
      }
    });
    
    // Add special gift product to cart via AJAX
    $(document).on("click", ".special-gift-ajax-btn", function () {
      var variantId = $(this).attr("data-variant-id"); // Get selected variant ID
      var gift_qty = $(this).closest(".gift-product-content").find(".qty-input").val(); 
      var giftInputName = $(this).closest(".gift-product-content").find('.gift-input-value').attr("name"); 
      
      //get item data
      var parent_item_id = $(this).closest(".cart-item").attr("data-item-id");
      var parent_item_qty = $(this).closest(".cart-item").attr("data-item-qty");

      AddToCart(variantId, gift_qty, $(this),giftInputName);
    });
  
    function AddToCart(variantId, gift_qty, btn,giftInputName) {
      let cartDrawer = document.querySelector("cart-drawer");
      let sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id);
      let sectionsUrl = window.location.pathname;
      var giftInputValue = $(btn).closest(".gift-product-content").find('.gift-input-value').val();  
      let propertiesObj = {};
      propertiesObj[giftInputName] = giftInputValue;
      
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: variantId,
          quantity: gift_qty,
          properties: propertiesObj, 
          sections: sectionsToRender,
          sections_url: sectionsUrl,
        },
        dataType: "json",
        success: function (response) {
          // Re-render cart drawer contents after successful addition
          cartDrawer.renderContents(response);
        },
        error: function (xhr, status, error) {
          // Log any errors to the console
          console.error("AJAX error:", status, error, xhr.responseText);
        },
      });
    }

// ============== Special Product JS End ================

});
